import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ButtonSubmit, Form } from '@anytag/shared-atoms';
import { useAllAvailableCountryOptions } from '@anytag/shared-hooks';
import { SelectorField, TextField } from '@anytag/shared-molecules';
import { TikTokSignupFormRegisteredValues, TikTokSignupRegisteredFormKeys } from './types';

export const Template = () => {
  const { t } = useTranslation();
  const {
    getValues,
    formState: { isSubmitting }
  } = useFormContext<TikTokSignupFormRegisteredValues>();
  const { allAvailableCountryOptions } = useAllAvailableCountryOptions();

  const values = getValues();
  const hasAllFieldFilled = Object.values(values).every((field) => !!field);

  return (
    <>
      <Form.Body className="p-0">
        <div className="mx-auto my-0 w-178 px-10 pt-12 pb-4">
          <TextField<TikTokSignupRegisteredFormKeys>
            name="companyName"
            title={t('TextForm.Company Name')}
            placeholder={t<string>('Company Name')}
            required
          />
          <TextField<TikTokSignupRegisteredFormKeys>
            name="companyUrl"
            title={t('TextForm.Company URL')}
            placeholder="https://anytag.tech"
            required
          />

          <Form.Fields itemsPerRow={2}>
            <TextField<TikTokSignupRegisteredFormKeys>
              name="phoneNumber"
              placeholder="066020485707"
              title={t('TextForm.Phone Number')}
              required
            />
            <SelectorField<TikTokSignupRegisteredFormKeys>
              name="countryId"
              title={t('Selector.Country')}
              options={allAvailableCountryOptions}
              required
            />
          </Form.Fields>
        </div>
      </Form.Body>

      <Form.Footer>
        <ButtonSubmit loading={isSubmitting} disabled={!hasAllFieldFilled} title={t('Button.Save')} />
      </Form.Footer>
    </>
  );
};
